import { DefaultResponse } from '../interfaces/index';
import api from '../api';
import { AxiosResponse } from 'axios';
import { MODALITIES } from '../constants/study.constant';
import { GENDER } from '../constants/common.constant';

const ROLE_URL = '/ris/attachment/v1';

export interface ParamsCreateAttachment {
  accession_number?: string; //? is Order_Group
  birth_date?: string;
  body_part?: string;
  department?: string;
  department_id?: string;
  device: string;
  device_code?: string;
  institution_code?: string;
  institution_id?: string;
  modality?: typeof MODALITIES[number];
  patient_id?: string;
  patient_name?: string;
  // pregenerated_series_instance_uid?: string; // Not using in FE
  pregenerated_study_instance_uid?: string;
  sex?: GENDER;
  study_comment?: string;
  study_datetime: string;
  study_description?: string;
  study_instance_uid?: string;
  visit_id?: string;
}
export interface ResponseCreateAttachment extends DefaultResponse {
  data: {
    study_instance_uid: string;
  };
}
export const createAttachment = async (data: ParamsCreateAttachment) => {
  const response = (await api({
    url: `${ROLE_URL}/upload`,
    method: 'POST',
    data,
  })) as AxiosResponse<ResponseCreateAttachment>;

  return response.data;
};
